ngPercentage.$inject = [];

/* @ngInject */
function ngPercentage() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            value: '=ngPercentage',
            round: '@round'
        }
    };
    return directive;

    function link(scope, element) {
        scope.$watch('value', function (percentage) {
            percentage = parseFloat(percentage).toFixed(3) * 100;

            element
                .html(percentage.toFixed(1) + '%');
        });
    }
}

export default ngPercentage;